import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RotateIcon from "../../../assets/svg/icons/mobile-rotate.inline.svg";
import { getAuthHeader, getAuthToken, Logout } from "../../Auth/Utils";
import { freespinGameIframeUrl } from "./Config";

const GameIframeLogged = ( { username, gameCode } ) => {
  const [freespinGameUrl, setFreespinGameUrl] = useState(false);
  const [freespinGameError, setFreespinGameError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (username) {
      //getLotteryIframeUrl(setFsGameUrl);
      getFreespinIframeUrl(gameCode, setFreespinGameUrl, setFreespinGameError);
    }
    if (navigator.userAgent.indexOf( "Android" ) !== -1) {
      const loggedInUser = document.getElementById('logged-in-user');
      loggedInUser.classList.add('android');
    }
  }, [username, gameCode]);

  const getFreespinIframeUrl = async (gameCode, setFreespinGameurl, setFreespinGameError) => {
    if(!getAuthToken){
      return false;
    }
    let body = JSON.stringify({code: gameCode});

    const response = await fetch(freespinGameIframeUrl, {
      method: 'POST',
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
    });
    if (response.ok) {
      let json = await response.json();
      if (json.error && json.message) {
        setFreespinGameError(json.message);
        if(json.error_type === 'session_expired'){
          Logout();
        }
      } else {
        setFreespinGameurl(json.url);
      }
    } else {
      console.log("Game Iframe Error HTTP: " + response.status);
      let json = await response.json();
      if(json.code === 'jwt_auth_invalid_token'){
        Logout();
      }
    }
  };

  return (
    <div id="game-page-wrap">
      {username && (
        <div>
          <div className="logged-in-user" id="logged-in-user">
            {freespinGameUrl ? (
              <div className="mobile-landscape">
                <div className="mobile-fixed-wrap">
                  <div className="iframe-container-game" id="iframe-container-game">
                    <iframe title={gameCode + " Game"} scrolling={'no'} src={freespinGameUrl} />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {freespinGameError ? <div id="fs-frame-error" className="error-msg fs-frame-error">{freespinGameError}</div> :
                  <div className="game-loading">กำลังโหลดข้อมูล...</div>
                }
              </div>
            )}
          </div>
          <div className="mobile-portrait">
            <div className="rotate-icon-container">
              <p>Please rotate your device</p>
              <RotateIcon/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GameIframeLogged;

GameIframeLogged.propTypes = {
  username: PropTypes.string,
};
